<app-loading *ngIf="loading"></app-loading>
<form (ngSubmit)="onSearch()" [formGroup]="searchForm">

    <!-- From Date -->
    <div class="ts-form-field">
        <label class="ts-label">From Date</label>
        <input type="date" class="ts-input" placeholder="Choose a date" formControlName="fromDate">
    </div>

    <!-- To Date -->
    <div class="ts-form-field">
        <label class="ts-label">To Date</label>
        <input type="date" class="ts-input" placeholder="Choose a date" formControlName="toDate">
    </div>

    <button class="btn-primary form-button" aria-label="Search" type="submit"
        [disabled]="loading">Search</button>
    <button class="btn-outlined form-button" aria-label="Reset" type="reset" (click)="onReset()"
        [disabled]="loading">Reset</button>

</form>
